import { SUB_DIRECTORY } from "../../common/constant";

const ContactCard = (props) => {
    const avtar = {
        width:"50px",
        height:"50px",
        backgroundColor : "gray",
        borderRadius: "50%",

    }
    return(
        <>
                <div  >
                    <img src={`${SUB_DIRECTORY}${props.image}`} style={avtar} alt="..."/>
                    <p className="text-secondary mb-0 mt-3">{props.location}</p>
                    <h6 className="text-bold">{props.name}</h6>
                    <p className="mb-1">Contact No : <a tel={props.contact}>{props.contact}</a></p>
                    <p className="mb-1">Email : <a tel={props.email}>{props.email}</a></p>
                    <p>{props.description}</p>
                 </div>
        </>
    )
}
export default ContactCard